var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('section',[_c('v-layout',{staticClass:"blue--text",attrs:{"column":"","align-center":"","justify-center":""}},[_c('input',{attrs:{"type":"file"},on:{"change":_vm.onFileSelected}}),_vm._v(" "),_c('v-btn',{on:{"click":_vm.onUpload}},[_vm._v("Upload")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b8d962","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IQFirmware.vue
// module id = null
// module chunks = 